import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import css from './ExternalOrgEmptyState.css';

function AgencyEmptyState({ agencyName = '', agencyId = '' }) {
    return (
        <div className={css.container}>
            <div className={css.title}>
                <Translate id="STATIC.PAGES.PARTNERS_PORTAL.EMPTY_STATE_TITLE" />
            </div>
            <div className={css.descriptionBlock}>
                <div className={css.description}>
                    <Translate id="STATIC.PAGES.PARTNERS_PORTAL.EMPTY_STATE_DESCRIPTION" />
                </div>
                <a
                    className={css.learnMore}
                    href="https://support.singular.net/hc/en-us/articles/13186948937371-Onboarding-Guide-for-Agency-Partners"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <Translate id="STATIC.PAGES.PARTNERS_PORTAL.EMPTY_STATE_LEARN_MORE" />
                </a>
            </div>
            <div className={css.infoBox}>
                <div className={css.infoRow}>
                    <span className={css.infoLabel}>
                        <Translate id="STATIC.PAGES.PARTNERS_PORTAL.EMPTY_STATE_AGENCY_NAME_LABEL" />
                    </span>
                    <span className={css.infoValue}>{agencyName}</span>
                </div>
                <div className={css.infoRow}>
                    <span className={css.infoLabel}>
                        <Translate id="STATIC.PAGES.PARTNERS_PORTAL.EMPTY_STATE_AGENCY_ID_LABEL" />
                    </span>
                    <span className={css.infoValue}>{agencyId}</span>
                </div>
            </div>
        </div>
    );
}

AgencyEmptyState.propTypes = {
    agencyName: PropTypes.string,
    agencyId: PropTypes.string,
};

export default AgencyEmptyState;
